var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classNames},[(_vm.suptitle)?_c('span',{staticClass:"BaseHeading__Suptitle",domProps:{"textContent":_vm._s(_vm.suptitle)}}):_vm._e(),_c(_vm.tagName,{tag:"component",staticClass:"BaseHeading__Title",domProps:{"innerHTML":_vm._s(_vm.title)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }